import { Pool } from '../../../../../../apis/pool.api';
import {
  CPSConfigAlarmElement,
  IProduct,
  IProductFunctionnality,
} from '../../../IProduct';
import { IMaster } from '../../../IMaster';
import { P00039DataRxTxIndex } from '../../P00039Sync';

export function P0003605Alarm(
  pool: Pool,
  productClass: IProduct,
  masterClass: IMaster,
  getValue: any,
): CPSConfigAlarmElement[] {
  let res: CPSConfigAlarmElement[] = [];

  if (getValue('icSAlarme') === 1) {
    if (getValue('icSFinBidon') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CHLORE,
        functionalityTitle: 'P0003605.dashboard.injectionCL',
        title: 'P0003605.status.bidon',
      });
    }

    if (getValue('icSSecuriteDesinfection') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CHLORE,
        functionalityTitle: 'P0003605.dashboard.injectionCL',
        title: 'P0003605.status.securiteDesinfection',
      });
    }

    if (getValue('icSVigilenceChlore') === 1) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CHLORE,
        functionalityTitle: 'P0003605.dashboard.injectionCL',
        title: 'P0003605.status.securiteSurdosage',
        ctaTitle: 'P0003605.status.securiteSurdosage.value',
        ctaFn: (editValue: any) => {
          editValue(
            P00039DataRxTxIndex.InjectionChlore_Controle,
            'icCAckUtilisateur',
            1,
          );
        },
      });
    }

    if (masterClass.hasProduct(pool, productClass) === 2) {
      res.push({
        productClass: productClass,
        functionality: IProductFunctionnality.INJECTION_CHLORE,
        functionalityTitle: 'P0003605.dashboard.injectionCL',
        title: 'P0003605.status.connexionProduit',
      });
    }
  }

  return res;
}
